import styled, { css } from 'styled-components';
import { getThemeProp } from 'theme';
import Time from 'components/Time';

export const SDescription = styled.div`
  color: ${getThemeProp('colors.slateGray')};
  font-size: 11px;
  line-height: 16px;
  overflow-wrap: break-word;
`;

export const SHeader = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-bottom: 6px;
`;

export const SContainer = styled.div`
  border-bottom: 1px solid ${getThemeProp('colors.athensGrey2')};
  padding: 15px 22px 14px;

  ${(props: { isActive: boolean }) =>
    props.isActive &&
    css`
      background-color: ${getThemeProp('colors.whiteLinen')};
      border-bottom-color: ${getThemeProp('colors.sideCarΒeige')};
      box-shadow: inset 2px 0 0 ${getThemeProp('colors.seaBuckthornOrange')};
    `}
`;

export const SName = styled.div`
  color: ${getThemeProp('colors.fiordGrey')};
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
`;

export const STime = styled(Time)`
  color: ${getThemeProp('colors.gullGray')};
  display: inline-block;
  font-size: 10px;
  line-height: 13px;
`;
